export default {
  all: {
    id: 'bo_sellers-opportunities-pricing-filters-all',
    defaultMessage: 'All',
  },
}
